<template>
  <q-item-section
    clickable
    dense
    class="text-green-8 column default-padding-tb cursor-pointer"
  >
    <div
      class="row items-center min-height-32   full-width default-padding-tb default-padding-lr"
    >
      <q-item-label
        class="ellipsis full-width"
      >
        {{ broker.botName }}
        <q-tooltip>{{ broker.botName }}</q-tooltip>
      </q-item-label>
    </div>

    <div
      dense
      class="column"
    >
      <template v-for="template in templates">
        <q-separator
          :key="`temp-${template.id}`"
          class="full-width"
        />
        <div
          class="hover-gray"
          :key="template.id"
          :data-testid="`template-${template.id}`"
          @click="$emit('on-handler-template-click', getTemplate(template))"
        >
          <q-item-section
            class="label text-primary min-height-32 default-padding-tb default-padding-lr"
          >
            <q-item-label
              lines="1"
              class="ellipsis"
            >
              {{ template.displayName }}
            </q-item-label>
          </q-item-section>

          <q-tooltip
            anchor="top left"
            self="top right"
            :offset="[3, -5]"
            max-width="250px"
          >
            <div class="title">
              <span>{{ template.displayName }}</span>
            </div>

            <div>
              {{ bodyMessage(template) }}
            </div>
          </q-tooltip>
        </div>
      </template>
    </div>
  </q-item-section>
</template>

<script>
import { sanitizeName } from '@/components/utils/sanitizeName'

export default {
  props: {
    broker: {}
  },

  computed: {
    templates () {
      const list = Array.isArray(this.broker?.templates) ? this.broker.templates : []
      return list.map(t => ({ ...t, displayName: sanitizeName(t.name) }))
    }
  },

  methods: {
    bodyMessage (template) {
      try {
        const cfg = JSON.parse(template.message)
        let data = '<span>'
        if (cfg.header) data += `<strong>${cfg.header}</strong><br /><br />`
        if (cfg.data) data += `${cfg.data}`
        if (cfg.footer) data += `<br /><strong>${cfg.footer}</strong>`
        if (cfg.buttons?.length) data += `<br /><br />${cfg.buttons.map(({ text }) => `<button>${text}</button>`).join('&nbsp;')}`
        data += '</span>'
        for (const param of template.params) {
          data = data.replaceAll(param.name, `<strong>*${param.value}*</strong>`)
        }

        return data
      } catch {
        return template.message
      }
    },

    getTemplate (item) {
      const template = { ...item }
      template.broker = { ...this.broker }
      delete template.broker.templates
      return template
    },

    maxHeight (n) {
      n = n > 4 ? 4 : n
      return this.filter === '' ? { maxHeight: '0px' } : { maxHeight: `${n * 34}px` }
    }
  }

}
</script>

<style lang="sass">
  .default-padding-tb
    padding-top: 2px
    padding-bottom: 2px

  .default-padding-lr
    padding-left: 16px
    padding-right: 16px

  .min-height-32
    height: 32px

  .min-width
    min-width: 317px

  .hover-gray
    &:hover
      background-color: #eeeeee

</style>
